var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { get } from "lodash";
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import Grid from "../UI/Grid/Grid";
var VolumePromotionsList = /** @class */ (function (_super) {
    __extends(VolumePromotionsList, _super);
    function VolumePromotionsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Име', key: 'name', filter: false, sort: false },
            { name: 'От дата', key: 'begin_date', filter: false, sort: false },
            { name: 'До дата', key: 'end_date', filter: false, sort: false },
        ];
        _this.edit = function (rowItem) {
            var selectedId = get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.editItem(selectedId);
            }
        };
        _this.delete = function (rowItem) {
            var selectedId = get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0442\u043E\u0437\u0438 \u0441\u043B\u0430\u0439\u0434?");
            if (ask) {
                _this.props.deleteItem(selectedId);
            }
        };
        _this.onPage = function (_a) {
            var page = _a.page;
            _this.props.onPage(page + 1);
        };
        return _this;
    }
    VolumePromotionsList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, editAction: this.edit, paginator: true, lazy: true, total: get(meta, 'total_records', 0), rows: get(meta, 'per_page', 0), first: (get(meta, 'current_page', 0) - 1) * get(meta, 'per_page', 0), onPage: this.onPage, deleteAction: this.delete }));
    };
    return VolumePromotionsList;
}(React.Component));
// @ts-ignore
export default withRouter(VolumePromotionsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/VolumePromotions/VolumePromotionsList.tsx
// module id = 519
// module chunks = 0